import styled from "@emotion/styled";
import { COLOR_TERTIARY, MOBILE_SCREEN, BOX_SHADOW_ELEVATED } from "./theme";
import { ParagraphSmall } from "./typography/Paragraph";
import { useProgressTrackerState } from "../hooks/useProgressTrackerState";

const ProgressTrackerContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${COLOR_TERTIARY};
  padding: 8px 40px;
  border-radius: 56px;
  box-shadow: ${BOX_SHADOW_ELEVATED};
  gap: 16px;
  flex-direction: row;
  justify-content: space-between;
  transition: opacity 300ms ease-in-out;
  width: 100%;
  max-width: 728px;
  margin-left: 56px;

  ${MOBILE_SCREEN} {
    gap: 8px;
    padding: 8px 16px;
    border-radius: 0;
    margin-left: -24px;
    margin-right: -24px;
    margin-bottom: 32px;
    width: auto;
  }
`;

const ProgressSegmentsContainer = styled.div`
  display: flex;
  align-items: center;

  flex-direction: row;
  gap: 8px;
  flex: 1;

  ${MOBILE_SCREEN} {
    gap: 4px;
    width: 100%;
  }
`;

const ProgressSegment = styled.div<{ isActive: boolean }>`
  &:nth-of-type(1) {
    background-color: #c95a93;
  }
  &:nth-of-type(2) {
    background-color: #d677e3;
  }
  &:nth-of-type(3) {
    background-color: #af77e3;
  }
  &:nth-of-type(4) {
    background-color: #7c77e3;
  }
  &:nth-of-type(5) {
    background-color: #90dca6;
  }
  border-radius: 16px;
  ${(props) => (props.isActive ? "" : "background-color: #E5E5EF !important;")};
  transition: background-color 100ms ease-in-out;

  width: 100%;
  height: 3px;
`;

const ProgressTracker: React.FC = () => {
  const { currentStep, totalSteps, label, error, isLoading } =
    useProgressTrackerState();

  if (error) {
    return null;
  }

  return (
    <ProgressTrackerContainer style={{ opacity: isLoading ? 0 : 1 }}>
      <ProgressSegmentsContainer>
        {Array.from({ length: totalSteps }, (_, index) => (
          <ProgressSegment key={index} isActive={index < currentStep} />
        ))}
      </ProgressSegmentsContainer>
      <ParagraphSmall>{label}</ParagraphSmall>
    </ProgressTrackerContainer>
  );
};

export default ProgressTracker;
